import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-customer-location-info',
  templateUrl: './customer-location-info.component.html',
  styleUrls: ['./customer-location-info.component.css']
})
export class CustomerLocationInfoComponent implements OnInit {
  private map!: L.Map;
  private centroid: L.LatLngExpression = [42.3601, -71.0589];
  usersList: any= []
  customerInfo: any = [];
  search = ""
  latitude: any = "";
  longitude: any = "";
  LatLng: any = [];
  lat: any = "";
  lng: any = "";

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.initMap();
  }

  ngOnDestroy(){
    console.log("ngOnDestroy")
    this.map.remove();
  }

  private initMap(): void {
    let centroid1: L.LatLngExpression[]= [];

    this.generic_service.getAllCustomerResponse().subscribe(
      (res:any)=> {
        console.log(res)
        for(let i=0; i<res.response.length; i++){
          if(res.response[i].geoAddress != undefined && res.response[i].geoAddress != null){
            if(res.response[i].geoAddress.latitude != null
              && res.response[i].geoAddress.latitude != 'null'
              && !Number.isNaN(res.response[i].geoAddress.latitude)
              && res.response[i].geoAddress.latitude != undefined
              && res.response[i].geoAddress.latitude != 'undefined'
              && res.response[i].geoAddress.latitude != ''
              && res.response[i].geoAddress.latitude != '0'
              && res.response[i].geoAddress.longitude != null
              && res.response[i].geoAddress.longitude != 'null'
              && !Number.isNaN(res.response[i].geoAddress.longitude)
              && res.response[i].geoAddress.longitude != undefined
              && res.response[i].geoAddress.longitude != 'undefined'
              && res.response[i].geoAddress.longitude != ''
              && res.response[i].geoAddress.longitude != '0'
              ){
              let obj:L.LatLngExpression = [
                Number(res.response[i].geoAddress.latitude),
                res.response[i].geoAddress.longitude
              ]
              centroid1.push(obj)
            }
          }
        }
        this.customerInfo = res.response
        console.log(centroid1)
        
        let loc = 0;
        let zoom = 12
        if(localStorage.getItem('loc') != '' && localStorage.getItem('loc') != null && localStorage.getItem('loc') != undefined){
          loc = Number(localStorage.getItem('loc'))
          zoom = 20
        }

        this.map = L.map('map', {
          center: this.centroid,
          zoom: zoom
        });
    
        const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 18,
          minZoom: 2,
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        });
    
        // L.Icon.Default.imagePath='https://www.iconpacks.net/icons/2/free-location-icon-2955-thumb.png';
    
        // create 5 random jitteries and add them to map
        for(let i = 0; i < centroid1.length; i++){
         let loc = L.marker(centroid1[i] as L.LatLngExpression,{icon: this.defaultIcon}).bindPopup('a marker location').openPopup()
         loc.addTo(this.map)
        }
    
        
        tiles.addTo(this.map);
      },
      (err:any)=>{
        console.log(err)
      }
    )


    console.log(this.map);


  }

  defaultIcon = L.icon({
    iconUrl: 'assets/img/loc.png', // your path may vary ...
    iconSize: [30, 30],
    iconAnchor: [2, 2],
    popupAnchor: [0, -2]
  });



  getAllCustomerResponse(){
    this.generic_service.getAllCustomerResponse().subscribe(
      (res:any)=> {
        console.log(res)
        this.customerInfo = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  onChoseLocation(){
    localStorage.removeItem('loc')
    location.reload();
  }
  
  onChoseLocation1(event:any){
    // console.log(event)
    for(var i=0; i<this.customerInfo.length; i++){
      if(this.customerInfo[i].name == event.target.ngContext[22]){
        this.lat =  this.customerInfo[i].geoAddress.latitude;
        this.lng =  this.customerInfo[i].geoAddress.longitude

        this.LatLng = [this.lat, this.lng]
  
        console.log(this.LatLng);
      }
    }
  }

  singleLocation(index:any){
    localStorage.setItem('loc', index)
    location.reload();
  }
}